import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface FamilyMember {
  names: string;
  firstSurName: string;
  secondSurName: string;
  relationshipName: string;
  identityDocument: number;
  identityDocumentTypeId: number;
}

interface NavBarWithLoginProps {
  data?: {
    names: string;
    firstSurName: string;
    secondSurName: string;
    identityDocument: number;
    identityDocumentTypeId: string;
  };
  isLoggedIn?: boolean;
  family?: FamilyMember[];
  changeProfile?: Function;
  profileMain?: {
    names: string;
    firstSurName: string;
    secondSurName: string;
    identityDocument: number;
    identityDocumentTypeId: string;
    affiliateName: string;
  };
  indexProfile?: number;
}

const colors = [
  "#00B4E3",
  "#4E9D2D",
  "#0071A3",
  "#8CC63F",
  "#3E8EDE",
  "#49C3B1",
  "#0071CE",
  "#00B288",
  "#002FCE",
];

const NavBarWithLogin: React.FC<NavBarWithLoginProps> = ({
  data,
  isLoggedIn = false,
  family,
  changeProfile,
  profileMain,
  indexProfile,
}) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenMenu, setIsDropdownOpenMenu] = useState(false);
  const [isDropdownOpenMenuProfile, setIsDropdownOpenMenuProfile] =
    useState(false);
  const payload = data;
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleDropdownToggleMenu = () => {
    setIsDropdownOpenMenu(!isDropdownOpenMenu);
    setIsDropdownOpenMenuProfile(false);
  };
  const handleDropdownToggleMenuProfile = () => {
    setIsDropdownOpenMenuProfile(!isDropdownOpenMenuProfile);
    setIsDropdownOpenMenu(false);
  };
  const getFirstLetter = (word: string | null): string => {
    if (!word || word.trim() === "") {
      return "A";
    }
    return word.charAt(0).toUpperCase();
  };

  const handleLogout = () => {
    // Limpiar sessionStorage
    sessionStorage.clear();

    // Limpiar localStorage
    localStorage.clear();

    // Redirigir a la página de logout de Liferay
    window.location.href = "/c/portal/logout";
  };

  const Logo = "/documents/d/guest/Frame_2";
  const SalidaImage = "/documents/d/guest/salida-1";
  const FrameImage = "/documents/d/guest/Frame-1";
  const GroupImage3 = "/documents/d/guest/Group_3";
  const IconEmergencia = "/documents/d/guest/icon-emergncia";
  const IconEmergenciaWhite = "/documents/d/guest/vector_1-1-";

  return (
    <>
      <div className="menu_cont is-main">
        <Link
          to={isLoggedIn ? "/mi-perfil" : "/"}
          state={
            isLoggedIn
              ? {
                  payload: payload,
                  documentonumero: payload?.identityDocument,
                  tipodedoc: payload?.identityDocumentTypeId,
                }
              : undefined
          }
          className="menu_link-logo w-nav-brand"
        >
          <img
            loading="lazy"
            src={Logo}
            alt=""
            className="menu_logo is-medium is-whitevf"
          />
          <img
            src="/documents/d/guest/logo-mb"
            loading="lazy"
            alt=""
            className="menu_logomovil"
          ></img>
        </Link>
        {isLoggedIn && (
          <nav role="navigation" className="menu_linksmain w-nav-menu">
            <div className="menu_link-content">
              <Link
                to={"/mi-perfil/contratos"}
                state={{
                  payload: payload,
                  documentonumero: payload?.identityDocument,
                  tipodedoc: payload?.identityDocumentTypeId,
                }}
                className="menu_item is-black w-nav-link"
                style={{ cursor: "pointer" }}
              >
                Mis Contratos
              </Link>

              <a
                href={"/group/guest/emergencia"}
                className="cta-emergencia w-inline-block"
                data-senna-off="true"
              >
                <img
                  src={IconEmergencia}
                  loading="lazy"
                  alt=""
                  className="cta-emergencia_icon"
                />
                <div className="cta-emergencia_text">Llamada de emergencia</div>
              </a>

              <div className="menu_drop-user" onClick={handleDropdownToggle}>
                <div className="menu_item-ft">
                  <div
                    className="manu_item_letra is-jade"
                    style={{ backgroundColor: colors[indexProfile ?? -1] }}
                  >
                    {getFirstLetter(data?.names ?? null)}
                  </div>
                  <img
                    src={GroupImage3}
                    loading="lazy"
                    alt=""
                    className="menu_item-flech"
                  />
                </div>
                <div>Hola {data?.names}</div>
                <div className="menu_drop-ico btns w-icon-dropdown-toggle"></div>
                {isDropdownOpen && (
                  <div
                    className="menu_droped-listdual"
                    style={{ display: "flex" }}
                  >
                    <div className="menu_droped-cont">
                      <a
                        onClick={() =>
                          changeProfile && changeProfile("", "", true)
                        }
                        className="menu_item-user w-inline-block"
                      >
                        <div className="menu_item-ft">
                          <div className="manu_item_letra is-jade">
                            {getFirstLetter(profileMain?.affiliateName ?? null)}
                          </div>
                          <img
                            src={GroupImage3}
                            loading="lazy"
                            alt=""
                            className="menu_item-flech"
                          />
                        </div>
                        <div>{profileMain?.affiliateName}</div>
                      </a>
                      <div className="menu_item-seccion is-down">
                        {family &&
                          data &&
                          family.map((member, index) => (
                            <a
                              key={index}
                              onClick={() =>
                                changeProfile &&
                                changeProfile(
                                  member.identityDocument,
                                  member.identityDocumentTypeId,
                                  false,
                                  index
                                )
                              }
                              className="menu_droped-item w-inline-block"
                            >
                              <div className="menu_item-ft">
                                <div
                                  className="manu_item_letra is-jade"
                                  style={{ backgroundColor: colors[index] }}
                                >
                                  {getFirstLetter(member.names ?? null)}
                                </div>
                                <img
                                  src={GroupImage3}
                                  loading="lazy"
                                  alt=""
                                  className="menu_item-flech"
                                />
                              </div>
                              <div>
                                {member.names} {member.firstSurName}{" "}
                                <span className="no-bold">
                                  ({member.relationshipName})
                                </span>
                              </div>
                            </a>
                          ))}
                      </div>
                      <div className="menu_item-seccion in-movil">
                        <Link
                          to="/mi-perfil"
                          state={{
                            payload: payload,
                            documentonumero: payload?.identityDocument,
                            tipodedoc: payload?.identityDocumentTypeId,
                          }}
                          className="menu_item-pages w-inline-block"
                        >
                          <div>Inicio</div>
                        </Link>
                        <a
                          href={"/group/guest/sofi"}
                          className="menu_item-pages w-inline-block"
                          data-senna-off="true"
                        >
                          <div>Sofi</div>
                        </a>
                        <a
                          href={"/group/guest/teleconsulta"}
                          className="menu_item-pages w-inline-block"
                          data-senna-off="true"
                        >
                          <div>Teleconsulta</div>
                        </a>
                        {/*<Link
                          to={"/mi-perfil/reembolsos"}
                          className="menu_item-pages w-inline-block"
                          data-senna-off="true"
                        >
                          <div>Reembolso</div>
                        </Link>*/}
                      </div>
                      <div className="menu_item-seccion in-movile">
                        <button
                          onClick={handleLogout}
                          className="menu_droped-item is-close w-inline-block"
                          style={{
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            width: "100%",
                            textAlign: "left",
                          }}
                        >
                          <img
                            src={SalidaImage}
                            loading="lazy"
                            alt=""
                            className="menu_item-foto"
                          />
                          <div>Cerrar sesión</div>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </nav>
        )}
        <div className="menu_movile">
          <div
            className="menu_drop-user"
            onClick={handleDropdownToggleMenuProfile}
            data-w-id="7140db47-27d9-e97f-27e5-728379a4f628"
          >
            <img
              src={FrameImage}
              loading="lazy"
              alt=""
              className="menu_drop-image"
            />
            <div>Hola {data?.names}</div>
            <div className="menu_drop-ico btns w-icon-dropdown-toggle"></div>
            <div
              className="menu_droped-listdual"
              style={{ display: isDropdownOpenMenuProfile ? "flex" : "none" }}
            >
              <div className="menu_droped-cont">
                <a
                  onClick={() => changeProfile && changeProfile("", "", true)}
                  className="menu_item-user w-inline-block"
                  style={
                    family && family.length > 0
                      ? {}
                      : { borderBottom: "inherit" }
                  }
                >
                  <div className="menu_item-ft">
                    <div className="manu_item_letra is-jade">
                      {getFirstLetter(profileMain?.affiliateName ?? null)}
                    </div>
                    <img
                      src={GroupImage3}
                      loading="lazy"
                      alt=""
                      className="menu_item-flech"
                    />
                  </div>
                  <div>{profileMain?.affiliateName}</div>
                </a>
                <div className="menu_item-seccion is-down">
                  {family &&
                    data &&
                    family.map((member, index) => (
                      <a
                        key={index}
                        onClick={() =>
                          changeProfile &&
                          changeProfile(
                            member.identityDocument,
                            member.identityDocumentTypeId,
                            false,
                            index
                          )
                        }
                        className="menu_droped-item w-inline-block"
                      >
                        <div className="menu_item-ft">
                          <div
                            className="manu_item_letra is-jade"
                            style={{ backgroundColor: colors[index] }}
                          >
                            {getFirstLetter(member.names ?? null)}
                          </div>
                          <img
                            src={GroupImage3}
                            loading="lazy"
                            alt=""
                            className="menu_item-flech"
                          />
                        </div>
                        <div>
                          {member.names} {member.firstSurName}{" "}
                          <span className="no-bold">
                            ({member.relationshipName})
                          </span>
                        </div>
                      </a>
                    ))}
                </div>
                <div className="menu_item-seccion in-movil">
                  <Link
                    to="/mi-perfil"
                    state={{
                      payload: payload,
                      documentonumero: payload?.identityDocument,
                      tipodedoc: payload?.identityDocumentTypeId,
                    }}
                    className="menu_item-pages w-inline-block"
                  >
                    <div>Inicio</div>
                  </Link>
                  <a
                    href={"/group/guest/sofi"}
                    className="menu_item-pages w-inline-block"
                    data-senna-off="true"
                  >
                    <div>Sofi</div>
                  </a>
                  <a
                    href={"/group/guest/teleconsulta"}
                    className="menu_item-pages w-inline-block"
                    data-senna-off="true"
                  >
                    <div>Teleconsulta</div>
                  </a>
                  {/*<Link
                    to={"/mi-perfil/reembolsos"}
                    className="menu_item-pages w-inline-block"
                  >
                    <div>Reembolso</div>
                  </Link>*/}
                </div>
                <div className="menu_item-seccion in-movile">
                  <button
                    onClick={handleLogout}
                    className="menu_droped-item is-close w-inline-block"
                    style={{
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    <img
                      src="/documents/d/guest/salida-1_1"
                      loading="lazy"
                      alt=""
                      className="menu_item-foto"
                    />
                    <div>Cerrar sesión</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={handleDropdownToggleMenu}
            className="menu-button w-nav-button"
            data-w-id="b81b686b-22c6-f7cb-601d-710709839f58"
          >
            <div
              className="menu_open-img w-icon-nav-menu"
              style={{ display: isDropdownOpenMenu ? "none" : "block" }}
            ></div>
            <img
              src="/documents/d/guest/Vector_4"
              loading="lazy"
              alt=""
              className="menu_close-img"
              style={{ display: isDropdownOpenMenu ? "block" : "none" }}
            />
          </div>
          <a
            href={"/group/guest/emergencia"}
            className="cta-emergencia-mobile w-inline-block"
            data-senna-off="true"
          >
            <img
              src={IconEmergenciaWhite}
              loading="lazy"
              alt=""
              className="cta-emergencia_icon is-mobile"
            />
            <div className="cta-emergencia_text is-mobile">
              Llamada de emergencia
            </div>
          </a>
        </div>
      </div>
      <div
        className="w-nav-overlay"
        data-wf-ignore=""
        id="w-nav-overlay-0"
        style={{ display: isDropdownOpenMenu ? "block" : "none" }}
      >
        <nav
          role="navigation"
          className="menu_linksmain w-nav-menu"
          style={{
            height: "1477.59px",
            transition: "all, transform 400ms",
            transform: "translateX(0px)",
          }}
          {...(isDropdownOpenMenu
            ? { "data-nav-menu-open": "true" }
            : { "data-nav-menu-close": "true" })}
        >
          <div className="menu_link-contentmovil">
            <Link
              to={"/mi-perfil/contratos"}
              state={{
                payload: payload,
                documentonumero: payload?.identityDocument,
                tipodedoc: payload?.identityDocumentTypeId,
              }}
              className="menu_link-movil w-inline-block"
            >
              <div>Mis Contratos</div>
              <img src="/documents/d/guest/Vector-2_1" loading="lazy" alt="" />
            </Link>
            <Link
              to="/mi-perfil"
              state={{
                payload: payload,
                documentonumero: payload?.identityDocument,
                tipodedoc: payload?.identityDocumentTypeId,
              }}
              className="menu_link-movil w-inline-block"
            >
              <div>Inicio</div>
              <img src="/documents/d/guest/Vector-2_1" loading="lazy" alt="" />
            </Link>
            <a
              href={"/group/guest/sofi"}
              className="menu_link-movil w-inline-block"
              data-senna-off="true"
            >
              <div>Sofi</div>
              <img src="/documents/d/guest/Vector-2_1" loading="lazy" alt="" />
            </a>
            <a
              href={"/group/guest/teleconsulta"}
              className="menu_link-movil w-inline-block"
              data-senna-off="true"
            >
              <div>Teleconsulta</div>
              <img src="/documents/d/guest/Vector-2_1" loading="lazy" alt="" />
            </a>
            {/*<Link
              to={"/mi-perfil/reembolsos"}
              className="menu_link-movil w-inline-block"
              data-senna-off="true"
            >
              <div>Reembolso</div>
              <img src="/documents/d/guest/Vector-2_1" loading="lazy" alt="" />
            </Link>*/}
            <button
              onClick={handleLogout}
              className="menu_link-movil cs w-inline-block"
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
                width: "100%",
                textAlign: "left",
              }}
            >
              <div className="menu_link-movil-cont">
                <img src="/documents/d/guest/salida-1" loading="lazy" alt="" />
                <div>Cerrar sesión</div>
              </div>
            </button>
          </div>
        </nav>
      </div>
    </>
  );
};

export default NavBarWithLogin;
